import { Box, Select, Option, FormControl, FormLabel, FormHelperText, Checkbox, Typography } from "@mui/joy";
import { Controller } from "react-hook-form";
import { TASK_STATUSES, COLOR_OPTIONS } from "./constants";

// Task Status Select Component
export const TaskStatusSelect = ({ control, rules, name }: any) => (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
            <FormControl error={!!fieldState.error} sx={{ mt: 0.8 }}>
                <Select
                    placeholder="Select status"
                    value={field.value}
                    slotProps={{ listbox: { sx: { zIndex: 1100 } } }}
                    onChange={(_, value) => field.onChange(value || "")}
                >
                    {TASK_STATUSES.map((status) => (
                        <Option key={status.id} value={status.id} sx={{ zIndex: 10000 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 12,
                                        height: 12,
                                        borderRadius: "50%",
                                        bgcolor: status.color,
                                    }}
                                />
                                {status.name}
                            </Box>
                        </Option>
                    ))}
                </Select>
                {fieldState.error && <FormHelperText>{fieldState.error.message}</FormHelperText>}
            </FormControl>
        )}
    />
);

// Color Picker Component
export const ColorPicker = ({ watch, setValue }: any) => (
    <Box flex={1}>
        <FormLabel>Task Color</FormLabel>
        <Typography level="body-xs" sx={{ color: "text.secondary", mb: 1 }}>
            Choose a color to categorize and visually organize this task on the calendar
        </Typography>
        <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
            {COLOR_OPTIONS.map((colorOption) => (
                <Box
                    key={colorOption.value}
                    sx={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        bgcolor: colorOption.bgColor,
                        border: "2px solid",
                        borderColor: watch("color") === colorOption.value ? colorOption.textColor : "transparent",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.2s ease",
                        "&:hover": {
                            transform: "scale(1.1)",
                        },
                    }}
                    onClick={() =>
                        setValue(
                            "color",
                            colorOption.value as
                                | "purple"
                                | "indigo"
                                | "violet"
                                | "red"
                                | "green"
                                | "blue"
                                | "orange"
                                | "yellow"
                        )
                    }
                />
            ))}
        </Box>
    </Box>
);
